import day from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import utc from "dayjs/plugin/utc";
import dayOfYear from "dayjs/plugin/dayOfYear";

[dayOfYear, isBetween, utc].forEach((plugin) => day.extend(plugin));
